// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.miui-stp-atv-grd-75 > div > span{
    border-image: linear-gradient(to right, #008331 75%, #eaeaf0 75%) 1 !important;
}
.miui-stp-atv-grd > div > span{
    border-image: linear-gradient(to right, #008331 25%, #eaeaf0 25%) 1 !important;
}
.miui-stp-atv > div > span{
    border-image: linear-gradient(to right, #008331 50%, #eaeaf0 50%) 1;
}
.MuiStep-horizontal:last-child > .MuiStepLabel-horizontal .MuiStepLabel-labelContainer{
    left: -40px;
}
.vz-stpper-wdth{
    width: 121.5%;
}
@media screen and (min-width:768px) {
    .vz-stpper-3{
        width: 145% !important;
    }
}
@media screen and (max-width:767px) {
    .top-pad {
        padding-top: 0rem !important;
      }
    .vz-stpper-wdth{
        margin-left: -0.5rem !important;
    }
    .MuiStep-alternativeLabel{
        flex: 0.5 !important;
    }
    .MuiStep-alternativeLabel .MuiStepConnector-alternativeLabel{
        width: 100%;
        top:10px;
    }
    .miui-stp-atv-0{
        flex: 1.5 !important ;
    }
    .vz-stpper-3 .miui-stp-atv .MuiStepConnector-alternativeLabel{
        width: 265% !important;
    }
    /* .MuiStepConnector-alternativeLabel{
        width: 85%;
        right: calc(65% + 10px) !important;
    } */
    .vz-stepper-wdth-mob-4 .miui-stp-atv .MuiStepConnector-alternativeLabel{
        right: calc(65% + 16px) !important;
    }
    .miui-stp-atv-0 .MuiStepConnector-alternativeLabel{
        width: 40% !important;
    }
    .vz-stepper-wdth-mob-4 .miui-stp-atv .MuiStepConnector-alternativeLabel{
        width: 244% !important;
    }
}
.chck-mrk-outline{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    max-width: 20px;
    max-height: 20px;
    background-color: #008331;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
@media screen and (min-width:767px) {
    .MuiStep-alternativeLabel:first-child{
        padding-left: 0px;
    } 
}
@media screen and (max-width:767px) {
    .mv-vw-vz-stpr{
        margin-top: 5rem !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/common/components/HorizontalProgress/VZStepper.css"],"names":[],"mappings":";AACA;IACI,8EAA8E;AAClF;AACA;IACI,8EAA8E;AAClF;AACA;IACI,mEAAmE;AACvE;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI;QACI,sBAAsB;IAC1B;AACJ;AACA;IACI;QACI,4BAA4B;MAC9B;IACF;QACI,+BAA+B;IACnC;IACA;QACI,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,QAAQ;IACZ;IACA;QACI,qBAAqB;IACzB;IACA;QACI,sBAAsB;IAC1B;IACA;;;OAGG;IACH;QACI,kCAAkC;IACtC;IACA;QACI,qBAAqB;IACzB;IACA;QACI,sBAAsB;IAC1B;AACJ;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":["\n.miui-stp-atv-grd-75 > div > span{\n    border-image: linear-gradient(to right, #008331 75%, #eaeaf0 75%) 1 !important;\n}\n.miui-stp-atv-grd > div > span{\n    border-image: linear-gradient(to right, #008331 25%, #eaeaf0 25%) 1 !important;\n}\n.miui-stp-atv > div > span{\n    border-image: linear-gradient(to right, #008331 50%, #eaeaf0 50%) 1;\n}\n.MuiStep-horizontal:last-child > .MuiStepLabel-horizontal .MuiStepLabel-labelContainer{\n    left: -40px;\n}\n.vz-stpper-wdth{\n    width: 121.5%;\n}\n@media screen and (min-width:768px) {\n    .vz-stpper-3{\n        width: 145% !important;\n    }\n}\n@media screen and (max-width:767px) {\n    .top-pad {\n        padding-top: 0rem !important;\n      }\n    .vz-stpper-wdth{\n        margin-left: -0.5rem !important;\n    }\n    .MuiStep-alternativeLabel{\n        flex: 0.5 !important;\n    }\n    .MuiStep-alternativeLabel .MuiStepConnector-alternativeLabel{\n        width: 100%;\n        top:10px;\n    }\n    .miui-stp-atv-0{\n        flex: 1.5 !important ;\n    }\n    .vz-stpper-3 .miui-stp-atv .MuiStepConnector-alternativeLabel{\n        width: 265% !important;\n    }\n    /* .MuiStepConnector-alternativeLabel{\n        width: 85%;\n        right: calc(65% + 10px) !important;\n    } */\n    .vz-stepper-wdth-mob-4 .miui-stp-atv .MuiStepConnector-alternativeLabel{\n        right: calc(65% + 16px) !important;\n    }\n    .miui-stp-atv-0 .MuiStepConnector-alternativeLabel{\n        width: 40% !important;\n    }\n    .vz-stepper-wdth-mob-4 .miui-stp-atv .MuiStepConnector-alternativeLabel{\n        width: 244% !important;\n    }\n}\n.chck-mrk-outline{\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    max-width: 20px;\n    max-height: 20px;\n    background-color: #008331;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n@media screen and (min-width:767px) {\n    .MuiStep-alternativeLabel:first-child{\n        padding-left: 0px;\n    } \n}\n@media screen and (max-width:767px) {\n    .mv-vw-vz-stpr{\n        margin-top: 5rem !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
